export default __webpack_public_path__ + "static/media/contacts_s.6fee73ba.jpg";